<div class="container">
	<div class="form-group">
    <h1>Administración</h1>
    <div class="col-sm">
      <button class="btn btn-success" (click)="addEmpresa()">Añadir Empresas</button>
      <button class="btn btn-success" (click)="delEmpresa()">Eliminar Empresas</button>
      <button class="btn btn-success" (click)="editEmpresa()">Editar Empresas</button>
    </div>
  </div>
</div>